import {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {getProbeSummary} from '../redux/portfolio.selector';

export function useLiveProbe(probeId) {
  var portfolio = probeId;
  if (portfolio) {
    //let livePortfolio = portfolioReducer?.data1;

    let livePortfolio = useSelector(
      ({portfolioReducer}) => portfolioReducer?.data1?.[portfolio],
    );
    //portfolio = livePortfolio[portfolio];
    let live = useSelector(({liveReducer}) => {
      const probe = {
        ...(liveReducer?.byIds?.[portfolio] || {}),
      };
      delete probe['volume'];
      delete probe['timestamp'];
      delete probe['channel'];
      return probe;
    }, shallowEqual);

    let probes = getProbeSummary(livePortfolio, live);

    // const veryLowHoldingLiqudity = probes
    //   .filter(i => i.veryLowHolding && i.liquidity)
    //   .map(i => i.liquidity);

    // const filteredProbes = probes.filter(i => !i.veryLowHolding);
    return {
      probes: probes,
      //liquidity: (portfolio?.liquidity ?? []).concat(veryLowHoldingLiqudity),
    };
  } else {
    return {
      probes: null,
    };
  }
}
